var React = require('react');

function ArrowBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.44 7.711l-.571-.575a.947.947 0 00-.675-.278.948.948 0 00-.674.278l-6.516 6.516L5.48 7.13a.946.946 0 00-.675-.278.947.947 0 00-.674.278l-.572.572a.955.955 0 000 1.349l7.767 7.794c.18.18.419.306.676.306h.003c.256 0 .495-.127.675-.306l7.759-7.773a.963.963 0 00.279-.682.954.954 0 00-.279-.678z","fill":"#fff"}));
}

ArrowBottom.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = ArrowBottom;

ArrowBottom.default = ArrowBottom;
